import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { REASON_MAX } from '../../../../../Consts/licences.const';
import {
  LicenceAssignDialogData,
  LicenceAssignDialogResult,
} from '../../../Interfaces/licence-assign-dialog.interface';

@Component({
  selector: 'app-licence-assign-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, MatIconModule, TranslateModule],
  templateUrl: './licence-assign-dialog.component.html',
  styleUrl: './licence-assign-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicenceAssignDialogComponent {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _dialogRef =
    inject<MatDialogRef<LicenceAssignDialogComponent, LicenceAssignDialogResult>>(MatDialogRef);

  readonly data = inject<LicenceAssignDialogData>(MAT_DIALOG_DATA);

  readonly reasonMax = REASON_MAX;

  readonly assignableUsers = this.data.users.filter((user) => !user.isDeleted);

  readonly formGroup: FormGroup = this._formBuilder.group({
    user_id: ['', [Validators.required]],
    reason: ['', [Validators.required, Validators.maxLength(REASON_MAX)]],
  });

  confirm(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this._dialogRef.close({
      userId: String(this.formGroup.value.user_id),
      reason: String(this.formGroup.value.reason).trim(),
    });
  }

  dismiss(): void {
    this._dialogRef.close();
  }
}
